import { View } from 'backbone.marionette';
import template from './index.jst';
import empty_template from '../empty_template.jst';
import final_template from '../final_template.jst';
import Radio from 'backbone.radio';
import RoundSlider from "../../../../../../core/views/components/RoundSlider";
import MatchUpHeaderSelect from "../MatchUpHeaderSelect";

const matchUpChannel = Radio.channel('match_up');

export class MatchUpHeader extends View {
	get template() {
		return template;
	}

	getTemplate() {
		if( this.empty_view ) {
			return empty_template;
		}
		else if( this.final_view ) {
			return final_template;
		}
		else {
			return template;
		}
	}

	regions() {
		return {
			header: '.js-matchup-page-header',
			round_selector: '.js-round-selector'
		}
	}

	childViewEvents() {
		return {
			'round:changed': 'onRoundChanged'
		}
	}

	initialize() {
		this.empty_view = false;
		this.final_view = false;

		this.setLayout()
			.initListeners();
	}

	setLayout() {

		if (!this.getRegion('header').hasView()) {
			this.showChildView('header', new MatchUpHeaderSelect());
		}
		if (!this.getRegion('round_selector').hasView()) {
			this.showChildView('round_selector', new RoundSlider());
		}

		return this;
	}

	initListeners() {
		this.listenTo(matchUpChannel, 'data:requested', this.onDataRequested);
		this.listenTo(matchUpChannel, 'preseason', this.showPreseason);
		this.listenTo(matchUpChannel, 'final', this.showFinals );

		return this;
	}

	showPreseason() {
		this.empty_view = true;
		this.render();
	}

	showFinals() {
		this.final_view = true;
		this.render();
	}

	onDataRequested({ league, round_id }) {
		const { avatar, name, fixture_item, rounds } = league.toJSON();

		this.initHeaderSelect({ avatar, name, fixture_item })
			.initRoundSelect({ rounds, selected: round_id });
	}

	initHeaderSelect({ avatar, name, fixture_item }) {
		this.getChildView('header').init({ avatar, name, fixture_item });
		return this;
	}

	initRoundSelect({ rounds, selected }) {
		this.getChildView('round_selector').init({
			rounds, selected
		});

		return this;
	}

	onRoundChanged(round_id) {
		matchUpChannel.trigger('round:changed', round_id);
	}
}

export default MatchUpHeader;